import React from "react"

import type { MetricRecordData } from "@/types/metrics/contracts"

import {
  FIELD_CONTAINER_STYLES,
  LABEL_ROW_STYLES,
  LABEL_STYLES,
  TEXT_INPUT_STYLES,
} from "../styles"

interface CustomAgentNeedsRepromptingConfigProps {
  metricRecordData: MetricRecordData
  onChange: (metric: MetricRecordData) => void
}

export const CustomAgentNeedsRepromptingConfig: React.FC<
  CustomAgentNeedsRepromptingConfigProps
> = ({ metricRecordData, onChange }) => {
  const handleMinSilenceGapChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = parseFloat(e.target.value)
    onChange({
      ...metricRecordData,
      metric_metadata: {
        ...metricRecordData.metric_metadata,
        min_silence_gap_seconds: isNaN(value) ? undefined : value,
      },
    })
  }

  return (
    <div className="space-y-4">
      <div className={FIELD_CONTAINER_STYLES}>
        <div className={LABEL_ROW_STYLES}>
          <label className={LABEL_STYLES}>
            Minimum Silence Gap (seconds){" "}
            <span className="text-coval-danger-text">*</span>
          </label>
        </div>
        <input
          type="number"
          step="0.5"
          min="0.1"
          className={TEXT_INPUT_STYLES}
          value={
            metricRecordData.metric_metadata?.min_silence_gap_seconds || ""
          }
          onChange={handleMinSilenceGapChange}
          placeholder="2.0"
        />
        <p className="text-xs text-coval-text-muted">
          Minimum silence duration before a user re-prompt is counted.
        </p>
      </div>
    </div>
  )
}
